import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tenacity',
  templateUrl: './tenacity.component.html',
  styleUrls: ['./tenacity.component.css']
})
export class TenacityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
